import { API_BASE_URL } from "@constants/urls";
import authAxios from "@helpers/lib/axios";
import { commerceBasePath } from "./constants";
import type { ActiveCodesResponse, ApplyAccessCodeResponse } from "./types";
const basePath = `${commerceBasePath}/access-code`;
export const applyAccessCode = async ({
	accessCode,
}: {
	accessCode: string;
}): Promise<ApplyAccessCodeResponse> => {
	const { data } = await authAxios.post(`${API_BASE_URL}/${basePath}`, {
		accessCode,
	});

	if (!data.data) {
		throw new Error(data.message);
	}
	return data;
};

export const getActiveCodes = async ({
	sku,
	productId,
}: {
	sku?: string;
	productId?: string;
}): Promise<ActiveCodesResponse[]> => {
	const url = `${API_BASE_URL}/${basePath}`;
	const { data } = await authAxios.get(url, {
		params: {
			sku,
			productId,
		},
	});
	return data.data;
};

export const resendAccessCode = async ({
	orderId,
	tenantId,
}: {
	orderId: string;
	tenantId: string;
}): Promise<{ success: boolean; message: string }> => {
	const { data } = await authAxios.post(`${API_BASE_URL}/${basePath}/resend`, {
		orderId,
		tenantId,
	});

	return data;
};
